module.exports = __webpack_public_path__ + "img/cns_ios14.215bfa60.png";